import script from "./icon-two-tones-twitter.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-twitter.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-twitter.vue?vue&type=style&index=0&id=46dc559e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46dc559e"]])

export default __exports__